export default "__VITE_ASSET__BGq9SODQ__"